export default __webpack_public_path__ + "static/media/chart-icon.ca751618.svg";